import React from 'react';
import { Moon, Sun } from 'lucide-react';
interface DarkModeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}
export function DarkModeToggle({
  isDark,
  onToggle
}: DarkModeToggleProps) {
  return <button onClick={onToggle} className="relative p-2.5 rounded-xl bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 hover:from-gray-200 hover:to-gray-300 dark:hover:from-gray-700 dark:hover:to-gray-800 transition-all duration-300 shadow-lg shadow-gray-300/50 dark:shadow-gray-900/50 hover:shadow-xl group" aria-label="Toggle dark mode" data-id="element-78">
      <div className="relative w-5 h-5" data-id="element-79">
        <Sun size={20} className={`absolute inset-0 text-amber-500 transition-all duration-300 ${isDark ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100'}`} data-id="element-80" />
        <Moon size={20} className={`absolute inset-0 text-blue-400 transition-all duration-300 ${isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-0'}`} data-id="element-81" />
      </div>
    </button>;
}